<template>
  <div class="payment-success">
    <SuccessIcon class="payment-success__icon" />
    <p class="payment-success__text">Ваш платіж успішно проведено.</p>
    <p class="payment-success__text">Дякуємо!</p>
    <router-link
      v-if="finalUrl && isLoggedIn"
      :to="finalUrl"
      class="payment-success__link"
    >
      Перейти до оформлення
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { default as SuccessIcon } from './success-icon';

export default {
  components: { SuccessIcon },
  props: {
    finalUrl: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters('currentUserModule', ['isUserDataReady']),
    isLoggedIn() {
      return this.isUserDataReady;
    },
  },
};
</script>

<style scoped lang="scss">
.payment-success {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  padding: 80px;
  margin: 40px 55px 120px;
  border: 1px solid #E4E4E7;
  border-radius: 16px;
  box-shadow: 0px 1px 2px 0px #0000000F, 0px 1px 3px 0px #0000001A;

  @media (max-width: 550px) {
    padding: 40px;
    margin: 25px 25px 50px;
  }

  &__icon {
    margin-bottom: 32px;
  }

  &__text {
    font-size: 32px;
    font-weight: 500;
    text-align: center;
    color: #313437;
    margin: 0;

    @media (max-width: 830px) {
      font-size: 28px;
    }

    @media (max-width: 550px) {
      font-size: 22px;
    }

    @media (max-width: 500px) {
      font-size: 18px;
    }

    @media (max-width: 450px) {
      font-size: 16px;
    }
  }

  &__link {
    margin-top: 32px;
    padding: 12px 32px;
    font-size: 18px;
    font-weight: 500;
    color: #fff;
    background-color: #007BBB;
    border-radius: 8px;
    text-decoration: none;

    &:hover {
      background-color: #005f8a;
    }

    @media (max-width: 550px) {
      font-size: 16px;
      padding: 10px 24px;
    }
  }
}
</style>